const space: any = [0, 5, 10, 15, 20, 25, 30, 35, 40]

space.m = '16px';
space.t = '59px';
space.d = '59px';
space.xd = '0px';

export default space;